class EmailPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-popup-dialog]');
    this.statusEl = this.querySelector('[data-popup-status]');
    // Two separate flags on purpose: closing without subscribing only silences the popup for
    // the current session (sessionStorage — clears when the tab/browser closes), so it comes
    // back next visit. Actually subscribing is permanent (localStorage) — it should never
    // show again on that browser regardless of session.
    this.subscribedKey = 'raise-email-popup-subscribed';
    this.sessionDismissedKey = 'raise-email-popup-dismissed-session';

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });

    this.dialog.addEventListener('close', () => this.dismissForSession());

    const status = this.statusEl ? this.statusEl.dataset.popupStatus : '';

    // Just came back from submitting the form (page reload): show the result once, and if
    // it succeeded, never show the popup again on this browser.
    if (status === 'success' || status === 'error') {
      this.open();
      if (status === 'success') this.markSubscribed();
      return;
    }

    if (this.isSubscribed() || this.isDismissedThisSession()) return;

    // Scroll-based triggering (IntersectionObserver on a marker) turned out unreliable on
    // some mobile/tablet browsers even after tuning the threshold — switched to a plain
    // delay so it's consistent everywhere. Configurable per-section via `delay_seconds`.
    const delay = Number(this.dataset.delaySeconds);
    const delayMs = (Number.isFinite(delay) ? delay : 3) * 1000;
    this.timer = setTimeout(() => this.open(), delayMs);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  isSubscribed() {
    try {
      return localStorage.getItem(this.subscribedKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  isDismissedThisSession() {
    try {
      return sessionStorage.getItem(this.sessionDismissedKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  open() {
    if (!this.dialog.open) this.dialog.showModal();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }

  dismissForSession() {
    try {
      sessionStorage.setItem(this.sessionDismissedKey, 'true');
    } catch (error) {
      // Private browsing / storage disabled — worst case the popup can show again.
    }
  }

  markSubscribed() {
    try {
      localStorage.setItem(this.subscribedKey, 'true');
    } catch (error) {
      // Private browsing / storage disabled — worst case the popup can show again.
    }
  }
}

customElements.define('email-popup', EmailPopup);
